import { forwardRef } from '@chakra-ui/react';
import { NavLink, NavLinkProps } from '../Nav';

export const NavbarLink = forwardRef<NavLinkProps, typeof NavLink>(
  (props, ref) => (
    <NavLink
      alignItems="center"
      display="flex"
      flexDirection="column"
      height="100%"
      justifyContent="center"
      position="relative"
      py={3}
      textStyle="textlink-large-medium"
      {...props}
      ref={ref}
    />
  ),
);
